import { NavLink } from "react-router-dom";

import { SummaryCard } from "../components/SummaryCard";
import { useContent } from "../hooks/useContent";
import { PageContainer } from "../layout/PageContainer";
import { api } from "../lib/api";
import { DetailCardGrid, DetailMetricGrid } from "./DeepDiveParts";

export function DemandPage() {
  const { data, loading, error } = useContent("demand-page", api.getDemand);

  return (
    <PageContainer
      eyebrow="Supporting Detail - Market Support"
      title="Demand detail for the Market Support surface"
      lede="This route is the demand-specific supporting layer beneath Market Support. It keeps the location and guest-demand detail available without acting like a separate primary investor surface."
    >
      {loading ? <div className="loading-panel shimmer-card">Loading demand summary...</div> : null}
      {error ? <div className="error-panel">{error}</div> : null}
      {data ? (
        <div className="stack-xl">
          <DetailMetricGrid
            items={[
              { title: "Demand Drivers", value: `${data.demandDrivers.length}`, detail: "Active location anchors" },
              { title: "Guest Segments", value: `${data.guestSegments.length}`, detail: "Supported on early read" },
              { title: "Risks", value: `${data.risks.length}`, detail: "Still open before underwriting" },
              { title: "Current Read", value: data.status, detail: "Demand summary status" }
            ]}
          />

          <DetailCardGrid
            items={[
              ...data.demandDrivers.slice(0, 4).map((item) => ({
                eyebrow: "Demand Driver",
                title: item.demandDriver,
                description: item.whyItMatters
              })),
              ...data.strengthAssessment.slice(0, 4).map((item) => ({
                eyebrow: "Strength Assessment",
                title: item.category,
                description: item.notes,
                fields: [{ label: "Current Read", value: item.currentRead }]
              }))
            ]}
          />

          <div className="grid-two">
            <SummaryCard eyebrow="Guest Segments" title="Who the location can plausibly support" description={data.locationOverview}>
              <ul className="bullet-list">
                {data.guestSegments.map((item) => (
                  <li key={item} className="bullet-item">{item}</li>
                ))}
              </ul>
            </SummaryCard>
            <SummaryCard eyebrow="Demand Risks" title="Why the demand case is not final yet" description={data.currentDemandRead}>
              <ul className="bullet-list">
                {data.risks.map((item) => (
                  <li key={item} className="bullet-item">{item}</li>
                ))}
              </ul>
            </SummaryCard>
          </div>

          <SummaryCard eyebrow="Conclusion" title={data.status} description={data.conclusion} />

          <SummaryCard
            eyebrow="Parent Surface"
            title="Return to Market Support for the combined commercial read"
            description="Use this page for demand-specific evidence. Use Market Support for the full demand, comps, precedent, and lead-concept plausibility view."
          >
            <div className="row-wrap gap-sm overview-go-deeper-actions">
              <NavLink to="/market-support" className="link-button link-button-secondary">
                Review Market Support
              </NavLink>
            </div>
          </SummaryCard>
        </div>
      ) : null}
    </PageContainer>
  );
}
